import type { PortalDataVizColors } from '../types';

export const dataVizColors: PortalDataVizColors = {
  pthalo: '#266284',
  royal: '#5667C3',
  cerulean: '#71C4FC',
  cyan: '#A8E0ED',
  sunrise: '#FFDB70',
  rose: '#FF6C7D',
  mint: '#64F3B3',
};
